import { render, staticRenderFns } from "./questionAnswer.vue?vue&type=template&id=2da68f24&scoped=true&"
import script from "./questionAnswer.vue?vue&type=script&lang=js&"
export * from "./questionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./questionAnswer.vue?vue&type=style&index=0&id=2da68f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da68f24",
  null
  
)

export default component.exports